import { makePropertyMetadataEntriesFetchKey, makePropertyMetadataEntriesFetchUrl } from './cacheKeys';
import { withQuickFetch } from './withQuickFetch';
export const fetchPropertyMetadataEntries = ({
  frameworkTypeIdentifier,
  appSettingName,
  httpClient
}) => withQuickFetch({
  requestName: makePropertyMetadataEntriesFetchKey({
    frameworkTypeIdentifier,
    appSettingName
  }),
  baseFetch: () => httpClient.get(makePropertyMetadataEntriesFetchUrl({
    frameworkTypeIdentifier,
    appSettingName
  }))
});